import store from '@/store';
import { loadExternal } from '@/utils/loadExternal/external';
import useModifyMobileGlobalEle from '@/utils/hooks/useModifyMobileGlobalEle';
//import useQueryMedia from '@/utils/hooks/useQueryMedia';

export default function ParamsObserver() {
    useModifyMobileGlobalEle();
    const params = new URLSearchParams(window.location.search);
    //const [isPhoneHorizontal, isPhoneVertical] = useQueryMedia();

    const platform = params.get('platform'),
        deviceType = params.get('deviceType');

    const isPad = useRef(false);

    useEffect(() => {

        try {
            loadExternal(window);
        } catch (e) { }

        store.appStore.setDeviceInfo({
            platform,
            deviceType,
        });

        //store.appStore.setHorizontal(isPhoneHorizontal);
        //store.appStore.setVertical(isPhoneVertical);


        if (isPad.current) return;

        if (platform === 'ios' && deviceType === 'pad') {
            isPad.current = true;
            document
                .getElementById('app')
                .style.setProperty('--status-bar-height', '.6rem');

            localStorage.setItem('barHeightIpad', '0.6')
        }

    }, [platform, deviceType]);

    useEffect(() => {

        console.log('test-----------')

        const setStatusBarHeight = (barHeight) => {
            console.log('断网后设置 --status-bar-height :', barHeight, window.location.href);

            document
                .getElementById('app')
                .style.setProperty('--status-bar-height', barHeight);

        }

        const isPhone = () => {
            let queryMedia2 = window.matchMedia(
                `(max-width:760px) and (max-aspect-ratio: 1/1)`
            );

            if (!queryMedia2.matches || navigator.userAgent.indexOf('iPhone') < 0) return false;

            return true;

        }

        let localHeightStrIphone = localStorage.getItem('barHeightMobile')

        let localHeightStrIpad = localStorage.getItem('barHeightIpad')

        console.log('断网后刷新页面重新设置 localHeightStrIphone:', localHeightStrIphone)

        console.log('断网后刷新页面重新设置 localHeightStrIpad:', localHeightStrIpad)

        if ((!!localHeightStrIphone && +localHeightStrIphone !== 0) && isPhone()) {
            setStatusBarHeight(+localHeightStrIphone + 'px');
            return;
        }

        if ((!!localHeightStrIpad && +localHeightStrIpad !== 0)) {
            setStatusBarHeight(localHeightStrIpad + 'rem')
        }

    }, [])

    return null;
}
